var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.48,
    height: 13.659,
    viewBox: "0 0 18.48 13.659",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-456789"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2007",
    "data-name": "Rectangle 2007",
    width: 18.48,
    height: 13.659,
    transform: "translate(0 0)",
    fill: "#040227"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22378",
    "data-name": "Group 22378",
    transform: "translate(0.023 0.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22377",
    "data-name": "Group 22377",
    transform: "translate(-0.023 -0.203)",
    clipPath: "url(#clip-path-456789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115964",
    "data-name": "Path 11594",
    d: "M16.613,0H1.51A1.512,1.512,0,0,0,0,1.51V12.082a1.512,1.512,0,0,0,1.51,1.51h15.1a1.512,1.512,0,0,0,1.51-1.51V1.51A1.512,1.512,0,0,0,16.613,0M1.51.755h15.1a.719.719,0,0,1,.157.032c-1.308,1.2-5.643,5.163-7.16,6.53a.757.757,0,0,1-1.1,0C7,5.95,2.66,1.983,1.353.787A.722.722,0,0,1,1.51.755M.755,12.082V1.51A.729.729,0,0,1,.8,1.3c1,.916,4.026,3.683,5.988,5.467C4.83,8.448,1.8,11.317.8,12.279a.728.728,0,0,1-.04-.2m15.858.755H1.51a.722.722,0,0,1-.17-.034c1.042-.994,4.088-3.879,6.008-5.522l.659.6a1.508,1.508,0,0,0,2.107,0l.66-.6c1.921,1.643,4.966,4.528,6.008,5.522a.722.722,0,0,1-.17.034m.755-.755a.729.729,0,0,1-.04.2c-1.009-.962-4.035-3.831-5.99-5.51C13.3,4.985,16.325,2.218,17.326,1.3a.73.73,0,0,1,.042.209Z",
    transform: "translate(0.008 0.066)",
    fill: "#040227"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.9d75a41688e4dec3bb88a737a679eb7c.svg";
export { ForwardRef as ReactComponent };